import styled, { css } from 'styled-components'
import { media } from 'styled-bootstrap-grid'

export const ContentBlock = styled.div<{ isCentered?: boolean }>`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);
  min-height: 216px;
  padding: 2.5rem 3rem;
  margin-bottom: 40px;
  ${p =>
    p.isCentered &&
    css`
      align-items: center;
      justify-content: center;
    `}
  
  ${media.xs`
    padding: 1.25rem 1.5rem;
  `}
  
  ${media.sm`
    padding: 2.5rem 3rem;
  `}
`

export default ContentBlock
